var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-class",staticStyle:{"overflow":"hidden"}},[_c('nav-bar'),_c('div',{staticClass:"main-container"},[(_vm.opened)?_c('side-bar'):_vm._e(),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }